import React from 'react';

import Grid from '@mui/material/Grid';

import { useTranslation } from 'react-i18next';

import { IndicatorValue } from './IndicatorValue';
import { useLabel } from '../hooks/useLabel';

export const IndicatorInfos = ({
  status,
  drawnLength,
  describedLength,
  theoreticalLength,
  walkLength,
  walkCycleLength,
  pointCrossNumber,
  pathCrossNumber,
}) => {
  const { t } = useTranslation();
  const { convertExplainLabel } = useLabel();

  const style = {
    container: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
    itemGrid: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
  };

  return (
    <Grid container sx={style.container} spacing={4}>
      <Grid
        sx={style.itemGrid}
        size={{
          xs: 12,
        }}
      >
        <IndicatorValue
          label={t('layer.sidewalks_theory_label')}
          value={Math.round(theoreticalLength) + ' km'}
          color='#A9A7A7'
          explain={convertExplainLabel('theoretical')}
          status={status}
        />
      </Grid>
      <Grid
        sx={style.itemGrid}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <IndicatorValue
          label={t('layer.sidewalks_painted_label')}
          value={Math.round(drawnLength) + ' km'}
          color='#42A5F5'
          explain={convertExplainLabel('drawn')}
          status={status}
        />
      </Grid>
      <Grid
        sx={style.itemGrid}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <IndicatorValue
          label={t('layer.sidewalks_saved_label')}
          value={Math.round(describedLength) + ' km'}
          color='#FF7043'
          explain={convertExplainLabel('described')}
          status={status}
        />
      </Grid>
      <Grid
        sx={style.itemGrid}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <IndicatorValue
          label={t('layer.walk_path_label')}
          value={Math.round(walkLength) + ' km'}
          color='#36CF11'
          explain={convertExplainLabel('walk')}
          status={status}
        />
      </Grid>
      <Grid
        sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <IndicatorValue
          label={t('layer.walk_cycle_label')}
          value={Math.round(walkCycleLength) + ' km'}
          color='#51ACC2'
          explain={convertExplainLabel('walk_cycle')}
          status={status}
        />
      </Grid>
      <Grid
        sx={style.itemGrid}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <IndicatorValue
          label={t('layer.crosswalk_point_label')}
          value={Math.round(pointCrossNumber)}
          color='#F9B357'
          explain={convertExplainLabel('crossing_point')}
          status={status}
        />
      </Grid>
      <Grid
        sx={style.itemGrid}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <IndicatorValue
          label={t('layer.crosswalk_line_label')}
          value={Math.round(pathCrossNumber)}
          color='#A455FF'
          explain={convertExplainLabel('crossing_path')}
          status={status}
        />
      </Grid>
    </Grid>
  );
};
